interface CrowIconProps {
  className?: string;
}

const CrowIcon = ({ className }: CrowIconProps) => (
  <svg
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    role="img"
  >
    {/* Legs */}
    <path
      d="M46 76 L44 94 M44 94 L38 98 M44 94 L49 98"
      stroke="#52525b"
      strokeWidth="3"
      fill="none"
      strokeLinecap="round"
    />
    <path
      d="M57 75 L60 94 M60 94 L54 98 M60 94 L65 98"
      stroke="#52525b"
      strokeWidth="3"
      fill="none"
      strokeLinecap="round"
    />
    {/* Wedge tail */}
    <path d="M30 60 L4 72 L12 83 L30 76 Z" fill="#52525b" />
    {/* Sleek elongated body, chest up toward the head */}
    <ellipse
      cx="49"
      cy="62"
      rx="29"
      ry="16"
      fill="#3f3f46"
      transform="rotate(-12 49 62)"
    />
    {/* Sheen on the back */}
    <ellipse
      cx="38"
      cy="53"
      rx="9"
      ry="4.5"
      fill="#71717a"
      transform="rotate(-20 38 53)"
    />
    {/* Wing raised in dance, with feather tips */}
    <path
      d="M42 60 Q28 50 16 26 L26 34 Q26 26 32 38 Q35 30 38 44 Q42 52 48 54 Z"
      fill="#52525b"
    />
    {/* Head */}
    <circle cx="64" cy="33" r="15" fill="#3f3f46" />
    {/* Sheen on the head */}
    <ellipse
      cx="60"
      cy="25"
      rx="7"
      ry="4"
      fill="#71717a"
      transform="rotate(-15 60 25)"
    />
    {/* Heavy pointed beak */}
    <path d="M77 30 L97 36 L77 41 Z" fill="#71717a" />
    {/* Eye */}
    <circle cx="66" cy="29" r="4.5" fill="#fff" />
    <circle cx="67.5" cy="29.5" r="2.2" fill="#18181b" />
  </svg>
);

export default CrowIcon;
